module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6LLXOO/cover.jpeg?1649199482777",
      "alt": "This image is the cover for the book Über Liebe und Ehe, Erotics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Über Liebe und Ehe, Erotics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Auszug: \"Wie die Linien auf der Innenseite der Hand zusammenlaufen, sich schneiden und wieder trennen, so bilden auch die Zeitgedanken in ihren einander begegnenden oder sich kreuzenden Bahnen ein geheimnisreiches Liniennetz. Der Wahrsager sucht in der Hand nach der Lebenslinie; der Deuter der Zeichen der Zeit forscht überall nach derselben Linie. Dies habe ich in diesem Teil auf dem Gebiete getan, auf dem ich vor allem ein »Verführer der Jugend« genannt wurde. Dieses Namens, den so mancher Grössere als ich vor mir erhalten hat, hoffe ich würdig zu bleiben. Denn wozu ich die Jugend zu verführen suchte, das war, ihre Seele zu vergrössern und ihr Leben zu verschönern durch das Wagnis, an die Seele und an den Traum in einer Welt zu glauben, in der alles darauf abzielt, die Seelen zu fesseln, und alle den Träumer belächeln.\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ellen Key\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ellen Karolina Sophie Key, * 11. Dezember 1849 auf Herrenhaus Sundsholm, Gemeinde Västervik; † 25. April 1926 im Haus Strand, Gemeinde Ödeshög) war eine schwedische Reformpädagogin und Schriftstellerin.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB Ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4cb4cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0